import type {PlaceDetails} from '@Components/google-map/google-map.types';

export async function getPlaceAddressByCords(location: google.maps.LatLng | google.maps.LatLngLiteral | google.maps.LatLngAltitudeLiteral): Promise<PlaceDetails | undefined> {
  await window.google.maps.importLibrary('geocoding');
  const geocoder = new window.google.maps.Geocoder();

  return geocoder.geocode({location}).then((response) => {
    if (response.results.length === 0) {
      return undefined;
    }
    return getPlaceById(response.results[0].place_id);
  });
}

export async function getPlaceById(id: string): Promise<PlaceDetails> {
  const placeLib = (await window.google.maps.importLibrary('places')) as google.maps.PlacesLibrary;
  const place = new placeLib.Place({id});

  await place.fetchFields({fields: ['displayName', 'formattedAddress', 'location', 'addressComponents']});
  return extractPlaceDetailsFromPlace(place);
}

export const extractPlaceDetailsFromPlace = (place: google.maps.places.Place): PlaceDetails => {
  const addressComponents = place.addressComponents ? getAddressComponents(place.addressComponents) : undefined;

  return {
    name: place.displayName ?? undefined,
    placeID: place.id,
    address: place.formattedAddress ?? undefined,
    longitude: place.location?.lng() ?? 0,
    latitude: place.location?.lat() ?? 0,
    ...addressComponents,
  };
};

const isGeocoderAddressComponent = (component: google.maps.GeocoderAddressComponent | google.maps.places.AddressComponent): component is google.maps.GeocoderAddressComponent => {
  return (component as google.maps.GeocoderAddressComponent).long_name !== undefined;
};

const getAddressComponents = (
  addressComponents: (google.maps.GeocoderAddressComponent | google.maps.places.AddressComponent)[]
): {country: string; province: string; city: string; postalCode: string} => {
  const details = {
    country: '',
    province: '',
    city: '',
    postalCode: '',
  };

  for (const component of addressComponents) {
    const componentType = component.types[0];

    const componentName = isGeocoderAddressComponent(component) ? component.long_name : component.longText;

    switch (componentType) {
      case 'country':
        details.country = componentName ?? '';
        break;
      case 'administrative_area_level_1':
        details.province = componentName ?? '';
        break;
      case 'locality':
        details.city = componentName ?? '';
        break;
      case 'postal_code':
        details.postalCode = componentName ?? '';
        break;
      default:
        break;
    }
  }

  return details;
};
